/* eslint-disable jsx-a11y/scope */
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { DELETE, GET, POST, PUT } from '../../../services/rest.service';

import Add from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { isObject } from 'lodash';
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import Select from 'react-select';
import swal from 'sweetalert';

import $ from 'jquery';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';

const JobPostingList = () => {
  const dispatch = useDispatch();
  const [records, setRecords] = useState([]);
  const [pages, setPages] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(-1);
  const [selectedOptionNannies, setSelectedOptionNannies] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getPage(1);
    $(function () {
      $('.scroll-main').on('scroll', function () {
        $('.scroll-child').scrollLeft($('.scroll-main').scrollLeft());
      });
      $('.scroll-child').on('scroll', function () {
        $('.scroll-main').scrollLeft($('.scroll-child').scrollLeft());
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPage = async (page) => {
    dispatch(showLoading());
    try {
      const { data } = await GET(`/admin/job-posting/get/${page}`);
      setRecords(data.Jobs);
      setPages(data.Pages);
      setTotal(data.Total);
      setCurrentPage(page);
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.message);
    }
  };

  const createRecord = () => {
    navigate(`/admin/postings/create`);
  };

  const handlePageClick = (e) => {
    getPage(e.selected + 1);
  };

  const onStatusChange = async (data, id) => {
    const payload = {
      status: data,
    };

    try {
      await PUT(`/admin/job-posting/edit/${id._id}`, payload);
      getPage(currentPage);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleDeleteRecord = async (record) => {
    const index = records.findIndex((x) => x._id === record._id);

    try {
      const result = await swal({
        title: 'Are you sure?',
        text: 'Are you sure you want to delete this Job Post? All their data will be lost forever.',
        icon: 'warning',
        buttons: ['No', 'Yes'],
      });
      if (result) {
        await DELETE(`/admin/job-posting/delete/${record._id}`, { status: 'Deleted' });
        setRecords([...records.slice(0, index), ...records.slice(index + 1)]);
        toast.error('Record Deleted Successfully');
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleOnChangeNannies = async (selectedOptionNannies, record) => {
    if (isObject(selectedOptionNannies)) {
      setSelectedOptionNannies(null);

      const payload = {
        jobPostingId: record._id,
        nannyId: selectedOptionNannies.value,
      };
      try {
        await POST(`/admin/job-posting/select-nanny`, payload);
        getPage(currentPage);
      } catch (err) {
        toast.error(err.message);
      }
    } else {
      setSelectedOptionNannies(null);
    }
  };

  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h6 className="text-uppercase mb-0">Job Listings</h6>

                <Button variant="outlined" color="secondary" sx={{ margin: 0, padding: '5px' }} onClick={createRecord}>
                  <Add />
                  Create
                </Button>
              </div>
              <div className="card-body">
                <div className={'table-responsive table-scroll'}>
                  <div className="scroll-main">
                    <div className="scroll-main-inner"></div>
                  </div>
                  <div className="scroll-child">
                    <table className="table card-text scroll-child-inner">
                      <thead>
                        <tr>
                          <th>Posted Date</th>
                          <th width="250">Job Title</th>
                          <th>Approx. Start Date</th>
                          <th>Type </th>
                          <th>Location</th>
                          <th>City</th>
                          <th>Rate</th>
                          <th>Status</th>
                          <th>Applicants</th>
                          <th className="text-center">Number of Applications</th>
                          <th className="text-center">#</th>

                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {records.map((record, index) => (
                          <tr key={index}>
                            <td scope="row">{moment(record.createdAt).format('MM/DD/YYYY')}</td>
                            <td scope="row">{record.title}</td>
                            <td scope="row">{moment(record.approxStartDate).format('MM/DD/YYYY')}</td>
                            <td scope="row">{record.type}</td>
                            <td scope="row">{record.location.address}</td>
                            <td scope="row">{record.city}</td>
                            <td scope="row">{record.rate}</td>
                            <td scope="row">
                              <StatusSelectBox value={record} onStatusChange={onStatusChange} />
                            </td>
                            {record.status === 'Filled' ? (
                              <td width="200" scope="row">
                                <Select
                                  value={
                                    record.filledBy
                                      ? {
                                          value: record.filledBy._id,
                                          label: record.filledBy.name,
                                        }
                                      : selectedOptionNannies
                                  }
                                  placeholder="Select Nannies"
                                  options={
                                    record.applications.length > 0
                                      ? record.applications.map((x) => {
                                          return {
                                            value: x._id,
                                            label: x.name,
                                          };
                                        })
                                      : []
                                  }
                                  onChange={(e) => {
                                    handleOnChangeNannies(e, record);
                                  }}
                                  className=""
                                />
                              </td>
                            ) : (
                              <td scope="row">----</td>
                            )}
                            <td
                              scope="row"
                              className="text-center c-pointer text-primary"
                              onClick={() => {
                                record.applications.length > 0 && navigate(`/admin/postings/applications/list/${record._id}`);
                              }}
                            >
                              {record.applications.length > 0 ? record.applications.length : '0'}
                            </td>
                            <td className="text-center">
                              <IconButton color="primary" sx={{ margin: 0, padding: '5px' }} aria-label="Edit" onClick={() => navigate(`/admin/postings/update/${record._id}`)}>
                                <EditIcon />
                              </IconButton>
                              <IconButton color="secondary" sx={{ margin: 0, padding: '5px' }} aria-label="Delete" onClick={() => handleDeleteRecord(record)}>
                                <DeleteIcon />
                              </IconButton>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mx-auto my-4">
            <ReactPaginate
              previousLabel={'previous'}
              nextLabel={'next'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={pages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              nextClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextLinkClassName={'page-link'}
              pageClassName={'page-item'}
              onPageChange={handlePageClick}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

const StatusSelectBox = ({ value, onStatusChange }) => {
  const [visible, setVisibility] = useState(false);
  const toggleDropDown = classNames('btn-group min-h-300 w-100');
  const dropDownMenu = classNames('dropdown-menu');
  const button = classNames(
    'btn dropdown-toggle btn-block',
    { 'btn-blue': value.status === 'Open' },
    { 'btn-success': value.status === 'Filled' },
    { 'btn-danger': value.status === 'Cancelled' },
    { 'btn-warning': value === 'On Hold' },
  );
  return (
    <div className={toggleDropDown}>
      <button type="button" className={button} onClick={() => setVisibility(!visible)} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        {value.status}
      </button>
      <div className={dropDownMenu} aria-labelledby="dropdownMenuButton">
        {['Open', 'On Hold', 'Filled', 'Cancelled'].map((status, index) => (
          <a href="#!" className={'dropdown-item'} key={index} onClick={() => onStatusChange(status, value)}>
            {status}
          </a>
        ))}
      </div>
    </div>
  );
};

export default JobPostingList;
